import type { MouseEvent } from 'react'
import { MoreHorizontal, Settings, Trash2 } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  onOpen: () => void
  onAskDelete: (e: MouseEvent) => void
}

export const InstructionTileControls = ({ onOpen, onAskDelete }: Props) => {
  const m = useMessages(messages)
  return (
    <div className="absolute top-3 right-3 flex items-center gap-2 z-20">
      <DropdownMenu>
        {/* white by design: белая таблетка, как у карточки курса (`WorkshopMenu`) — читается на любой обложке */}
        <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            className="flex h-9 items-center justify-center rounded-full bg-white text-[#1b1b20] shadow-sm transition hover:scale-105 hover:bg-white/90 motion-reduce:hover:scale-100 px-3.5 [@media(hover:hover)]:opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100 focus-visible:opacity-100"
            aria-label={m.menu}
          >
            <MoreHorizontal className="size-5" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[190px]">
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation()
              onOpen()
            }}
            className="text-[15px]"
          >
            <Settings className="size-[18px] mr-3" />
            {m.open}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={onAskDelete}
            className="text-[15px] text-destructive focus:text-destructive focus:bg-destructive/10"
          >
            <Trash2 className="size-[18px] mr-3" />
            {m.delete}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
